// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Platform_FranchiseResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for GET /platform/v1/franchises/:id — one resource (ADR-0019). */
import type { Platform_FranchiseRow } from './Platform_FranchiseRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Platform_FranchiseResponseDados {
item: Platform_FranchiseRow
}

export type Platform_FranchiseResponse = ApiResponse<Platform_FranchiseResponseDados>;

registerResponseContract('Platform_FranchiseResponse', {
  item: {
    type: 'object',
    required: true,
    fields: {
      id:                 { type: 'number',  required: true },
      name:               { type: 'string',  required: true },
      country:            { type: 'string',  required: false },
      currency:           { type: 'string',  required: false },
      status:             { type: 'string',  required: true },
      standing:           { type: 'string',  required: true },
      trade_name:         { type: 'string',  required: false },
      tax_id:             { type: 'string',  required: false },
      state_registration: { type: 'string',  required: false },
      email:              { type: 'string',  required: false },
      phone:              { type: 'string',  required: false },
      address_street:     { type: 'string',  required: false },
      address_number:     { type: 'string',  required: false },
      address_complement: { type: 'string',  required: false },
      address_district:   { type: 'string',  required: false },
      address_city:       { type: 'string',  required: false },
      address_state:      { type: 'string',  required: false },
      address_zip:        { type: 'string',  required: false },
    },
  },
})
